import { ChangeLogTargetType } from './types';

export const membershipChangeLogKeys = {
    all: ['membershipChangeLog'] as const,
    forTarget: (targetType: ChangeLogTargetType, targetId: string, includeSystem: boolean) =>
        ['membershipChangeLog', targetType, targetId, includeSystem] as const,
};
